<!-- <div id="terms">
<div class="container">
  <div class="d-flex justify-content-center mb-4">
    <app-logo [link]="DefualtPath"></app-logo>
  </div>
  <h1 class="mb-2">BidXSell Terms of Use</h1>

  <h2>ACCEPTANCE OF THE TERMS OF USE</h2>
  <p>
    Please read the Terms of Use carefully before you start to access or use
    the Website. These terms of use are entered into by and between You and
    Silk Road, LLC (“ <strong> Company </strong> ”). The following terms and
    conditions (“<strong> Terms of Use </strong> ”) govern your access to and
    use of any website owned, managed or operated by Company or any of its
    affiliates, including but not limited to bidxsell.com, including any
    content, functionality, and services including accessing and participating
    in any/all auctions offered on or through bidxsell.com (the “
    <strong>Website”</strong>).
  </p>
  <p>
    By accessing or using the Website, completing the registration process, or
    using the services of the website, including but not limited to accessing
    and participating in any/all auctions offered on or through the Website
    (the "<strong>Services</strong>"), you and any person with access to your
    user credentials to include usernames and passwords, agree to be fully
    bound by the Terms of Use of the website. The Terms of Use apply to all
    visitors, guests, users and others who access or use the Website,
    including all persons participating in our auctions
    (“<strong>Users</strong>”). You further agree to secure your account
    credentials including username and password, and neither bidxsell.com nor
    the company are responsible for any unauthorized access to your user
    account.
  </p>
  <p>
    If you (a) do not agree to the Terms of Use of the website, (b) are not 18
    years of age on the date of registration as a user, or (c) have been
    previously restricted from using the website under another username or
    alias, you must terminate use of the website immediately. You may use or
    access the Website only if you can form a binding contract with Company,
    and only in compliance with the Terms of Use and all applicable local,
    state, national, and international laws, rules and regulations.
  </p>
  <p>
    The Company reserves the right to change the Terms of Use without notice
    to you in its sole discretion. All changes are effective immediately when
    we post them, and apply to all access to and use of the Website
    thereafter. You agree and acknowledge that it is your responsibility to
    review the Terms of Use to be aware of any changes to these terms.
    Continued use of the website will bind you to the modified Terms of Use.
  </p>

  <h2>INTELLECTUAL PROPERTY</h2>
  <p>
    Silk Road LLC and/or BidXSell.com is the owner or the licensee of all
    intellectual property rights in our Services and the Website, including:
    (a) all copyrights, executables, source code, object code, databases,
    functionality, information, software, algorithms, technology, website
    designs, audio, video, text, photographs, and graphics in the Services and
    Website (whether copyrightable or not) (collectively, the "Content"); (b)
    the trademarks, service marks, trade dress, trade names, logos, and any
    other similar indicia of source or origin, together with all goodwill
    connected with the use and symbolized by any of the foregoing contained
    therein (the "Marks"); (c) trade secrets, know-how, inventions (whether or
    not patentable), discoveries, improvements, technology, business and
    technical information, databases, data compilations and collections,
    tools, methods, processes, techniques, and other confidential and
    proprietary information and all rights therein (“<u> Trade Secrets</u>”)
    related to the Website or Services; and (d) all other intellectual
    property and proprietary rights. Our Content and Marks are protected by
    copyright and trademark laws (and various other intellectual property
    rights and unfair competition laws) and treaties in the United States and
    around the world. No right, title, or interest in or to the Website or any
    Content on the Website is transferred to you, and all rights not expressly
    granted are reserved by the Company. Any use of the Website not expressly
    permitted by these Terms of Use is a breach of these Terms of Use and may
    violate copyright, trademark, and other laws.
  </p>

  <h2>USER REPRESENTATIONS</h2>
  <p>
    By using the Services, you represent and warrant that: (1) all
    registration information you submit will be true, accurate, current, and
    complete; (2) you will maintain the accuracy of such information and
    promptly update such registration information as necessary; (3) you have
    the legal capacity and you agree to comply with all Terms of Use set forth
    herein; (4) you are not a minor in the jurisdiction in which you reside;
    (5) you will not access the Services through automated or non-human means,
    whether through a bot, script or otherwise; (6) you will not use the
    Services for any illegal or unauthorized purpose; and (7) your use of the
    Services will not violate any applicable law or regulation. If you provide
    any information that is untrue, inaccurate, not current, or incomplete, we
    have the right to suspend or terminate your account and refuse any and all
    current or future use of the Services (or any portion thereof).
  </p>

  <h2>USER REGISTRATION</h2>
  <p>
    To access portions of the website, you will be required to complete the
    user registration. You agree:
  </p>
  <ol>
    <li>
      To keep a current credit card in good standing on file for downpayments
      on purchases made through the website.
    </li>
    <li>
      To keep your password confidential and to be responsible for any use of
      your account and password.
    </li>
    <li>
      To immediately report any breach or loss of confidential credentials and
      agree to update/change account credentials to secure your account upon
      such breach or loss.
    </li>
    <li>
      The Company is not liable for breach or loss of account credentials and
      cannot be held liable for unauthorized access to your account.
    </li>
    <li>
      That you are liable for all activities conducted through your account.
    </li>
    <li>That you are at least 18 years old at the time of registration.</li>
    <li>
      That you are legally able to enter a binding contract with the Company.
    </li>
    <li>
      That you are legally authorized to register for another person, company,
      or entity and you warrant that you are authorized to bind such to the
      Terms of Use of the website.
    </li>
    <li>
      The information you provide is true, complete, and accurate and you
      agree to provide accurate changes to the registration information if and
      when necessary.
    </li>
  </ol>

  <h2>PAYMENTS</h2>
  <p>
    You agree to provide current, complete, and accurate purchase and account
    information for all purchases made via the Website. You further agree to
    provide and maintain a credit card on file in your user account that is in
    good standing and has an ample credit limit. Every purchase made by any
    bidder on the Website is subject to a $500 non-refundable downpayment at
    the time of purchase. Downpayments will be charged to the credit card of
    the winning bidder immediately at close of any auction lot. If the
    purchase price is less than $500, the full purchase price will be
    immediately charged to the credit card on file. The winning bidder will
    receive an invoice for the balance of the purchase price which will be due
    and payable upon receipt. Payments for balances due and payable will be
    accepted by VISA, MasterCard, American Express credit cards, wire
    transfer, ACH, Google Pay, Apple Pay, PayPal, and HyperPay.
  </p>
  <p>
    You further agree to promptly update account and payment information,
    including email address, physical address, phone number, payment method,
    payment card expiration date, and card security code so that we can
    complete your downpayments or transactions and contact you as needed.
    Sales tax will be added to the price of purchases as deemed required by
    applicable tax law. We may change the downpayment amount at any time. All
    payments shall be in US dollars.
  </p>
  <p>
    You agree to pay all charges associated with your auction purchase and
    authorize us to charge your chosen payment provider for any such amounts.
    We reserve the right to correct any errors or mistakes in billing and
    invoicing even if we have already requested or received payment.
  </p>
  <p>
    If for any reason your account remains unpaid beyond the due date, late
    fees and interest charges may be applied to your account. Any account that
    remains unpaid for a period of 30 days after the due date may be
    terminated at the discretion of the Website. Fees and interest will remain
    your responsibility regardless of the status of your account. In the event
    legal action is necessary to collect on any balance(s) due, you agree to
    reimburse the Company for all expenses incurred to recover sums due,
    including attorneys’ fees and other legal expenses.
  </p>

  <h2>CONDUCT/PROHIBITED USES</h2>
  <p>
    Your use of the Website is subject to all applicable laws and regulations.
    You may not access or use the Website for any purpose other than that for
    which we make the Website available. The Website may not be used in
    connection with any commercial endeavors except those that are
    specifically endorsed or approved by us.
  </p>
  <p>
    By posting information in or otherwise using any interactive services that
    may be available to you on or through the Website, you agree not to use
    the website:
  </p>
  <ol>
    <li>
      in any way that violates any applicable federal, state, local, or
      international law or regulation (including, without limitation, any laws
      regarding the export of data or software to and from the US or other
      countries);
    </li>
    <li>
      for the purpose of exploiting, harming, or attempting to exploit or harm
      minors in any way by exposing them to inappropriate content, asking for
      personally identifiable information, or otherwise;
    </li>
    <li>
      to transmit, or procure the sending of, any advertising or promotional
      material including any “junk mail,” “spam,” or any other similar
      solicitation;
    </li>
    <li>
      to impersonate or attempt to impersonate the Company, a Company
      employee, another user, or any other person or entity including, without
      limitation, by using email addresses or screen names associated with any
      of the foregoing;
    </li>
    <li>
      to engage in any other conduct that restricts or inhibits any third
      party’s use or enjoyment of the Website, or which, as determined by us,
      may harm the Company or users of the Website, or expose them to
      liability;
    </li>
    <li>
      in any manner that could disable, overburden, damage, or impair the site
      or interfere with any other third party’s use of the Website, including
      their ability to engage in real time activities through the Website;
    </li>
    <li>
      with use of any robot, spider, or other automatic device, process, or
      means to access the Website for any purpose, including monitoring or
      copying any of the material on the Website;
    </li>
    <li>
      to monitor or copy any of the material on the Website, or for any other
      purpose not expressly authorized in these Terms of Use;
    </li>
    <li>
      with the use of any device, software, or routine that interferes with
      the proper working of the Website;
    </li>
    <li>
      to introduce any viruses, Trojan horses, worms, logic bombs, or other
      material that is malicious or technologically harmful;
    </li>
    <li>
      to attempt to gain unauthorized access to, interfere with, damage, or
      disrupt any parts of the Website, the server on which the Website is
      stored, or any server, computer, or database connected to the Website;
      and
    </li>
    <li>
      to otherwise attempt to interfere with the proper working of the
      Website.
    </li>
  </ol>

  <h2>WEBSITE CONTENT/RELIANCE ON INFORMATION POSTED</h2>
  <p>
    The information presented on or through the Website is made available
    solely for general information purposes. We do not warrant the accuracy,
    completeness, or usefulness of this information. Any reliance you place on
    such information is strictly at your own risk. We disclaim all liability
    and responsibility arising from any reliance placed on such materials by
    you or any other visitor to the Website, or by anyone who may be informed
    of any of its contents.
  </p>
  <p>
    This Website may include content provided by third parties, including
    materials provided by other users, bloggers, and third-party licensors,
    syndicators, aggregators, and/or reporting services. All statements and/or
    opinions expressed in these materials, and all articles and responses to
    questions and other content, other than the content provided by the
    Company, are solely the opinions and the responsibility of the person or
    entity providing those materials. These materials do not necessarily
    reflect the opinion of the Company. We are not responsible, or liable to
    you or any third party, for the content or accuracy of any materials
    provided by any third parties.
  </p>

  <h2>USER CONTRIBUTIONS</h2>
  <p>
    The Website may contain message boards, chat rooms, personal web pages or
    profiles, forums, bulletin boards, auctions, and other interactive
    features (collectively, “<strong>Interactive Services</strong>”) that
    allow users to post, bid, submit, publish, display, or transmit to Company
    or other users content or materials (collectively, “<strong
    >User Contributions</strong
    >”) on or through the Website.
  </p>
  <p>
    Any User Contribution you post or communicate to the Website whether by
    electronic mail or other means, for any reason shall be considered
    non-confidential and non-proprietary. By providing any User Contribution
    on the Website, you grant us and our affiliates and service providers, and
    each of their and our respective licensees, successors, and assigns the
    right to use, reproduce, modify, perform, display, distribute, and
    otherwise disclose to third parties any such material. You represent and
    warrant that: (1) you own or control all rights in and to the User
    Contributions and have the right to grant the license granted above to us
    and our affiliates and service providers, and each of their and our
    respective licensees, successors, and assigns; (2) all of your User
    Contributions do and will comply with the Terms of Use; (3) you understand
    and acknowledge that you are responsible for any User Contributions you
    submit or contribute, and you, not the Company, have full responsibility
    for such content, including its legality, reliability, accuracy, and
    appropriateness; and (4) you are responsible and/or liable to any third
    party for the content or accuracy of any User Contributions posted by you
    or any other user of the Website.
  </p>

  <h2>COPYRIGHT INFRINGEMENT</h2>
  <p>
    If you believe that any User Contributions violate your copyright, please
    send us a notice of copyright infringement. It is the policy of the
    Company to terminate the user accounts of repeat infringers.
  </p>

  <h2>CONTRIBUTION LICENSE</h2>
  <p>
    You and the Website agree that we may access, store, process, and use any
    information and personal data that you provide following the terms of the
    Privacy Policy and your choices (including settings).
  </p>
  <p>
    By submitting suggestions or other feedback regarding the Website, you
    agree that we can use and share such feedback for any purpose without
    compensation to you.
  </p>

  <h2>MOBILE APP LICENSE</h2>
  <h3>Use License</h3>
  <p>
    If you access the Website via the App, then we grant you a revocable,
    non-exclusive, non-transferable, limited right to install and use the App
    on wireless electronic devices owned or controlled by you, and to access
    and use the App on such devices strictly in accordance with the terms and
    conditions of this mobile application license contained in these Terms of
    Use. You shall not:
  </p>
  <ol>
    <li>
      except as expressly permitted by applicable law, decompile, reverse
      engineer, disassemble, attempt to derive the source code of, or decrypt
      the App;
    </li>
    <li>
      make any modification, adaptation, improvement, enhancement,
      translation, or derivative work from the App;
    </li>
    <li>
      violate any applicable laws, rules, or regulations in connection with
      your access or use of the App;
    </li>
    <li>
      remove, alter, or obscure any proprietary notice (including any notice
      of copyright or trademark) posted by us or the licensors of the App;
    </li>
    <li>
      use the App for any revenue-generating endeavor, commercial enterprise,
      or other purpose for which it is not designed or intended;
    </li>
    <li>
      make the App available over a network or other environment permitting
      access or use by multiple devices or users at the same time;
    </li>
    <li>
      use the App for creating a product, service, or software that is,
      directly or indirectly, competitive with or in any way a substitute for
      the App;
    </li>
    <li>
      use the App to send automated queries to any website or to send any
      unsolicited commercial email; or
    </li>
    <li>
      use any proprietary information or any of our interfaces or our other
      intellectual property in the design, development, manufacture,
      licensing, or distribution of any applications, accessories, or devices
      for use with the App.
    </li>
  </ol>

  <h3>Apple and Android Devices</h3>
  <p>
    The following terms apply when you use the App obtained from either the
    Apple Store or Google Play (each an "App Distributor") to access the
    Website:
  </p>
  <ol>
    <li>
      the license granted to you for our App is limited to a non-transferable
      license to use the application on a device that utilizes the Apple iOS
      or Android operating systems, as applicable, and in accordance with the
      usage rules set forth in the applicable App Distributor’s terms of
      service;
    </li>
    <li>
      we are responsible for providing any maintenance and support services
      with respect to the App as specified in the terms and conditions of this
      mobile application license contained in these Terms of Use or as
      otherwise required under applicable law, and you acknowledge that each
      App Distributor has no obligation whatsoever to furnish any maintenance
      and support services with respect to the App;
    </li>
    <li>
      in the event of any failure of the App to conform to any applicable
      warranty, you may notify the applicable App Distributor, and the App
      Distributor, in accordance with its terms and policies, may refund the
      purchase price, if any, paid for the App, and to the maximum extent
      permitted by applicable law, the App Distributor will have no other
      warranty obligation whatsoever with respect to the App;
    </li>
    <li>
      you represent and warrant that (i) you are not located in a country that
      is subject to a US government embargo, or that has been designated by
      the US government as a "terrorist supporting" country and (ii) you are
      not listed on any US government list of prohibited or restricted
      parties;
    </li>
    <li>
      you must comply with applicable third-party terms of agreement when
      using the App, e.g., if you have a VoIP application, then you must not
      be in violation of their wireless data service agreement when using the
      App; and
    </li>
    <li>
      you acknowledge and agree that the App Distributors are third-party
      beneficiaries of the terms and conditions in this mobile application
      license contained in these Terms of Use, and that each App Distributor
      will have the right (and will be deemed to have accepted the right) to
      enforce the terms and conditions in this mobile application license
      contained in these Terms of Use against you as a third-party beneficiary
      thereof.
    </li>
  </ol>

  <h2>SOCIAL MEDIA</h2>
  <p>
    As part of the functionality of the Website, you may link your account
    with online accounts you have with third-party service providers (each
    such account, a "Third-Party Account") by either: (1) providing your
    Third-Party Account login information through the Website; or (2) allowing
    us to access your Third-Party Account, as is permitted under the
    applicable terms and conditions that govern your use of each Third-Party
    Account. You represent and warrant that you are entitled to disclose your
    Third-Party Account login information to us and/or grant us access to your
    Third-Party Account, without breach by you of any of the terms and
    conditions that govern your use of the applicable Third-Party Account, and
    without obligating us to pay any fees or making us subject to any usage
    limitations imposed by the third-party service provider of the Third-Party
    Account. By granting us access to any Third-Party Accounts, you understand
    that (1) we may access, make available, and store (if applicable) any
    content that you have provided to and stored in your Third-Party Account
    (the "Social Network Content") so that it is available on and through the
    Website via your account, including without limitation any friend lists
    and (2) we may submit to and receive from your Third-Party Account
    additional information to the extent you are notified when you link your
    account with the Third-Party Account. Depending on the Third-Party
    Accounts you choose and subject to the privacy settings that you have set
    in such Third-Party Accounts, personally identifiable information that you
    post to your Third-Party Accounts may be available on and through your
    account on the Website. Please note that if a Third-Party Account or
    associated service becomes unavailable or our access to such Third-Party
    Account is terminated by the third-party service provider, then Social
    Network Content may no longer be available on and through the Website. You
    will have the ability to disable the connection between your account on
    the Website and your Third-Party Accounts at any time. PLEASE NOTE THAT
    YOUR RELATIONSHIP WITH THE THIRD-PARTY SERVICE PROVIDERS ASSOCIATED WITH
    YOUR THIRD-PARTY ACCOUNTS IS GOVERNED SOLELY BY YOUR AGREEMENT(S) WITH
    SUCH THIRD-PARTY SERVICE PROVIDERS. We make no effort to review any Social
    Network Content for any purpose, including but not limited to, for
    accuracy, legality, or non-infringement, and we are not responsible for
    any Social Network Content. You acknowledge and agree that we may access
    your email address book associated with a Third-Party Account and your
    contacts list stored on your mobile device or tablet computer solely for
    purposes of identifying and informing you of those contacts who have also
    registered to use the Website. You can deactivate the connection between
    the Website and your Third-Party Account by contacting us using the
    contact information below or through your account settings (if
    applicable). We will attempt to delete any information stored on our
    servers that was obtained through such Third-Party Account, except the
    username and profile picture that become associated with your account.
  </p>

  <h2>THIRD-PARTY WEBSITES AND CONTENT</h2>
  <p>
    The Website may contain (or you may be sent via the Site or App) links to
    other websites ("Third-Party Websites") as well as articles, photographs,
    text, graphics, pictures, designs, music, sound, video, information,
    applications, software, and other content or items belonging to or
    originating from third parties ("Third-Party Content"). Such Third-Party
    Websites and Third-Party Content are not investigated, monitored, or
    checked for accuracy, appropriateness, or completeness by us, and we are
    not responsible for any Third-Party Websites accessed through the Website
    or any Third-Party Content posted on, available through, or installed from
    the Website, including the content, accuracy, offensiveness, opinions,
    reliability, privacy practices, or other policies of or contained in the
    Third-Party Websites or the Third-Party Content. Inclusion of, linking to,
    or permitting the use or installation of any Third-Party Websites or any
    Third-Party Content does not imply approval or endorsement thereof by us.
    If you decide to leave the Website and access the Third-Party Websites or
    to use or install any Third-Party Content, you do so at your own risk, and
    you should be aware these Terms of Use no longer govern. You should review
    the applicable terms and policies, including privacy and data gathering
    practices, of any website to which you navigate from the Website or
    relating to any applications you use or install from the Website. Any
    purchases you make through Third-Party Websites will be through other
    websites and from other companies, and we take no responsibility
    whatsoever in relation to such purchases which are exclusively between you
    and the applicable third party. You agree and acknowledge that we do not
    endorse the products or services offered on Third-Party Websites and you
    shall hold us blameless from any harm caused by your purchase of such
    products or services. Additionally, you shall hold us blameless from any
    losses sustained by you or harm caused to you relating to or resulting in
    any way from any Third-Party Content or any contact with Third-Party
    Websites.
  </p>

  <h2>MONITORING, ENFORCEMENT AND SERVICES MANAGEMENT</h2>
  <p>We reserve the right, but not the obligation, to:</p>
  <ol>
    <li>
      monitor the Website and terminate or suspend your access to all or part
      of the Website for any or no reason, including any violation of the
      Terms of Use;
    </li>
    <li>
      take appropriate legal action against anyone who, in our sole
      discretion, violates the law or these Terms of Use, including without
      limitation, reporting such user to law enforcement authorities;
    </li>
    <li>
      in our sole discretion and without limitation, refuse, restrict access
      to, limit the availability of, or disable (to the extent technologically
      feasible) any of your Contributions or any portion thereof;
    </li>
    <li>
      in our sole discretion and without limitation, notice, or liability, to
      remove from the Website or otherwise disable all files and content that
      are excessive in size or are in any way burdensome to our systems; and
    </li>
    <li>
      otherwise manage the Website in a manner designed to protect our rights
      and property and to facilitate the proper functioning of the Website.
    </li>
  </ol>
  <p>
    Without limiting the foregoing, we have the right to cooperate fully with
    any law enforcement authorities or court order requesting or directing us
    to disclose the identity or other information of anyone posting any
    materials on or through the Website. YOU WAIVE AND HOLD HARMLESS THE
    COMPANY AND ITS AFFILIATES, LICENSEES, AND SERVICE PROVIDERS FROM ANY
    CLAIMS RESULTING FROM ANY ACTION TAKEN BY THE COMPANY DURING, OR TAKEN AS
    A CONSEQUENCE OF, INVESTIGATIONS BY EITHER THE COMPANY OR LAW ENFORCEMENT
    AUTHORITIES.
  </p>
  <p>
    However, we do not undertake to review all material before it is posted on
    the Website, and cannot ensure prompt removal of objectionable material
    after it has been posted. Accordingly, we assume no liability for any
    action or inaction regarding transmissions, communications, or content
    provided by any user or third party. We have no liability or
    responsibility to anyone for performance or nonperformance of the
    activities described in this section.
  </p>

  <h2>MODIFICATIONS AND INTERRUPTIONS</h2>
  <p>
    We reserve the right to change, modify, or remove the contents of the
    Website at any time or for any reason at our sole discretion without
    notice. However, we have no obligation to update any information on our
    Website. We also reserve the right to modify or discontinue all or part of
    the Website without notice at any time. We will not be liable to you or
    any third party for any modification, price change, suspension, or
    discontinuance of the Website.
  </p>
  <p>
    We cannot guarantee the Website will be available at all times. We may
    experience hardware, software, or other problems or need to perform
    maintenance related to the Website, resulting in interruptions, delays, or
    errors. We reserve the right to change, revise, update, suspend,
    discontinue, or otherwise modify the Website at any time or for any reason
    without notice to you. You agree that we have no liability whatsoever for
    any loss, damage, or inconvenience caused by your inability to access or
    use the Website during any downtime or discontinuance of the Website.
    Nothing in these Terms of Use will be construed to obligate us to maintain
    and support the Website or to supply any corrections, updates, or releases
    in connection therewith.
  </p>

  <h2>GOVERNING LAW</h2>
  <p>
    These Terms of Use and your use of the Website are governed by and
    construed in accordance with the laws of the Commonwealth of Kentucky
    applicable to agreements made and to be entirely performed within the
    Commonwealth of Kentucky, without regard to its conflict of law
    principles.
  </p>

  <h2>DISPUTE RESOLUTION</h2>
  <h3>Informal Negotiations</h3>
  <p>
    To expedite resolution and control the cost of any dispute, controversy,
    or claim related to these Terms of Use (each a "Dispute" and collectively,
    the "Disputes") brought by either you or us (individually, a "Party" and
    collectively, the "Parties"), the Parties agree to first attempt to
    negotiate any Dispute (except those Disputes expressly provided below)
    informally for at least thirty (30) days before initiating arbitration.
    Such informal negotiations commence upon written notice from one Party to
    the other Party.
  </p>

  <h3>Binding Arbitration</h3>
  <p>
    If the Parties are unable to resolve a Dispute through informal
    negotiations, the Dispute (except those Disputes expressly excluded below)
    will be finally and exclusively resolved by binding arbitration. YOU
    UNDERSTAND THAT WITHOUT THIS PROVISION, YOU WOULD HAVE THE RIGHT TO SUE IN
    COURT AND HAVE A JURY TRIAL. The arbitration shall be commenced and
    conducted under the Commercial Arbitration Rules of the American
    Arbitration Association ("AAA") and, where appropriate, the AAA’s
    Supplementary Procedures for Consumer Related Disputes ("AAA Consumer
    Rules"), both of which are available at the American Arbitration
    Association (AAA) website. Your arbitration fees and your share of
    arbitrator compensation shall be governed by the AAA Consumer Rules and,
    where appropriate, limited by the AAA Consumer Rules. The arbitration may
    be conducted in person, through the submission of documents, by phone, or
    online. The arbitrator will make a decision in writing, but need not
    provide a statement of reasons unless requested by either Party. The
    arbitrator must follow applicable law, and any award may be challenged if
    the arbitrator fails to do so. Except where otherwise required by the
    applicable AAA rules or applicable law, the arbitration will take place in
    Fayette County, Kentucky. Except as otherwise provided herein, the Parties
    may litigate in court to compel arbitration, stay proceedings pending
    arbitration, or to confirm, modify, vacate, or enter judgment on the award
    entered by the arbitrator.
  </p>
  <p>
    If for any reason, a Dispute proceeds in court rather than arbitration,
    the Dispute shall be commenced or prosecuted in the state and federal
    courts located in Fayette County, Kentucky, and the Parties hereby consent
    to, and waive all defenses of lack of personal jurisdiction, and forum non
    conveniens with respect to venue and jurisdiction in such state and
    federal courts. Application of the United Nations Convention on Contracts
    for the International Sale of Goods and the Uniform Computer Information
    Transaction Act (UCITA) are excluded from these Terms of Use.
  </p>
  <p>
    In no event shall any Dispute brought by either Party related in any way
    to the Website be commenced more than one (1) years after the cause of
    action arose. If this provision is found to be illegal or unenforceable,
    then neither Party will elect to arbitrate any Dispute falling within that
    portion of this provision found to be illegal or unenforceable and such
    Dispute shall be decided by a court of competent jurisdiction within the
    courts listed for jurisdiction above, and the Parties agree to submit to
    the personal jurisdiction of that court.
  </p>

  <h3>Restrictions</h3>
  <p>
    The Parties agree that any arbitration shall be limited to the Dispute
    between the Parties individually. To the full extent permitted by law, (a)
    no arbitration shall be joined with any other proceeding; (b) there is no
    right or authority for any Dispute to be arbitrated on a class-action
    basis or to utilize class action procedures; and (c) there is no right or
    authority for any Dispute to be brought in a purported representative
    capacity on behalf of the general public or any other persons.
  </p>

  <h3>Exceptions to Informal Negotiations and Arbitration</h3>
  <p>
    The Parties agree that the following Disputes are not subject to the above
    provisions concerning informal negotiations binding arbitration: (a) any
    Disputes seeking to enforce or protect, or concerning the validity of, any
    of the intellectual property rights of a Party; (b) any Dispute related
    to, or arising from, allegations of theft, piracy, invasion of privacy, or
    unauthorized use; and (c) any claim for injunctive relief. If this
    provision is found to be illegal or unenforceable, then neither Party will
    elect to arbitrate any Dispute falling within that portion of this
    provision found to be illegal or unenforceable and such Dispute shall be
    decided by a court of competent jurisdiction within the courts listed for
    jurisdiction above, and the Parties agree to submit to the personal
    jurisdiction of that court.
  </p>

  <h2>CORRECTIONS</h2>
  <p>
    There may be information on the Website that contains typographical
    errors, inaccuracies, or omissions, including descriptions, pricing,
    availability, and various other information. We reserve the right to
    correct any errors, inaccuracies, or omissions and to change or update the
    information on the Website at any time, without prior notice.
  </p>

  <h2>GEOGRAPHIC RESTRICTIONS</h2>
  <p>
    The owner of the Website is based in the Commonwealth of Kentucky. Access
    to the Website may not be legal by certain persons or in certain
    countries. If you access the Website from outside the United States, you
    do so on your own initiative and are responsible for compliance with local
    laws.
  </p>

  <h2>DISCLAIMER</h2>
  <p>
    You understand that we cannot and do not guarantee or warrant that files
    available for downloading from the internet or the Website will be free of
    viruses or other destructive code. You are responsible for implementing
    sufficient procedures and checkpoints to satisfy your particular
    requirements for anti-virus protection and accuracy of data input and
    output, and for maintaining a means external to our site for any
    reconstruction of any lost data.
  </p>
  <p>
    THE WEBSITE ARE PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU AGREE
    THAT YOUR USE OF THE WEBSITE WILL BE AT YOUR SOLE RISK. TO THE FULLEST
    EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED,
    IN CONNECTION WITH THE WEBSITE AND YOUR USE THEREOF, INCLUDING, WITHOUT
    LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
    PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR
    REPRESENTATIONS ABOUT THE ACCURACY OR COMPLETENESS OF THE WEBSITE' CONTENT
    OR THE CONTENT OF ANY WEBSITES OR MOBILE APPLICATIONS LINKED TO THE
    WEBSITE AND WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY (1)
    ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AND MATERIALS, (2) PERSONAL
    INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR
    ACCESS TO AND USE OF THE WEBSITE, (3) ANY UNAUTHORIZED ACCESS TO OR USE OF
    OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION AND/OR
    FINANCIAL INFORMATION STORED THEREIN, (4) ANY INTERRUPTION OR CESSATION OF
    TRANSMISSION TO OR FROM THE WEBSITE, (5) ANY BUGS, VIRUSES, TROJAN HORSES,
    OR THE LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE WEBSITE BY ANY
    THIRD PARTY, AND/OR (6) ANY ERRORS OR OMISSIONS IN ANY CONTENT AND
    MATERIALS OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF
    THE USE OF ANY CONTENT POSTED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE
    VIA THE WEBSITE. WE DO NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME
    RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A THIRD
    PARTY THROUGH THE WEBSITE, ANY HYPERLINKED WEBSITE, OR ANY WEBSITE OR
    MOBILE APPLICATION FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND WE
    WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY
    TRANSACTION BETWEEN YOU AND ANY THIRD-PARTY PROVIDERS OF PRODUCTS OR
    WEBSITE. AS WITH THE PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM
    OR IN ANY ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGMENT AND EXERCISE
    CAUTION WHERE APPROPRIATE.
  </p>

  <h2>LIMITATIONS OF LIABILITY</h2>
  <p>
    IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE TO
    YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL, EXEMPLARY,
    INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT, LOST
    REVENUE, LOSS OF DATA, OR OTHER DAMAGES ARISING FROM YOUR USE OF THE
    WEBSITE, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
    NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, OUR LIABILITY
    TO YOU FOR ANY CAUSE WHATSOEVER AND REGARDLESS OF THE FORM OF THE ACTION,
    WILL AT ALL TIMES BE LIMITED TO $500.00 USD. CERTAIN US STATE LAWS AND
    INTERNATIONAL LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR THE
    EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO YOU,
    SOME OR ALL OF THE ABOVE DISCLAIMERS OR LIMITATIONS MAY NOT APPLY TO YOU,
    AND YOU MAY HAVE ADDITIONAL RIGHTS.
  </p>

  <h2>INDEMNIFICATION</h2>
  <p>
    You agree to defend, indemnify, and hold us harmless, including our
    subsidiaries, affiliates, and all of our respective officers, agents,
    partners, and employees, from and against any loss, damage, liability,
    claim, or demand, including reasonable attorneys’ fees and expenses, made
    by any third party due to or arising out of: (1) use of the Website; (2)
    breach of these Terms of Use; (3) any breach of your representations and
    warranties set forth in these Terms of Use; (4) your violation of the
    rights of a third party, including but not limited to intellectual
    property rights; or (5) any overt harmful act toward any other user of the
    Website with whom you connected via the Website. Notwithstanding the
    foregoing, we reserve the right, at your expense, to assume the exclusive
    defense and control of any matter for which you are required to indemnify
    us, and you agree to cooperate, at your expense, with our defense of such
    claims. We will use reasonable efforts to notify you of any such claim,
    action, or proceeding which is subject to this indemnification upon
    becoming aware of it.
  </p>

  <h2>USER DATA</h2>
  <p>
    We will maintain certain data that you transmit to the Website for the
    purpose of managing the performance of the Website, as well as data
    relating to your use of the Website. Although we perform regular routine
    backups of data, you are solely responsible for all data that you transmit
    or that relates to any activity you have undertaken using the Website. You
    agree that we shall have no liability to you for any loss or corruption of
    any such data, and you hereby waive any right of action against us arising
    from any such loss or corruption of such data.
  </p>

  <h2>ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES</h2>
  <p>
    Visiting the Website, sending us emails, and completing online forms
    constitute electronic communications. You consent to receive electronic
    communications, and you agree that all agreements, notices, disclosures,
    and other communications we provide to you electronically, via email and
    on the Website, satisfy any legal requirement that such communication be
    in writing. YOU HEREBY AGREE TO THE USE OF ELECTRONIC SIGNATURES,
    CONTRACTS, ORDERS, AND OTHER RECORDS, AND TO ELECTRONIC DELIVERY OF
    NOTICES, POLICIES, AND RECORDS OF TRANSACTIONS INITIATED OR COMPLETED BY
    US OR VIA THE WEBSITE. You hereby waive any rights or requirements under
    any statutes, regulations, rules, ordinances, or other laws in any
    jurisdiction which require an original signature or delivery or retention
    of non-electronic records, or to payments or the granting of credits by
    any means other than electronic means.
  </p>

  <h2>CALIFORNIA USERS AND RESIDENTS</h2>
  <p>
    If any complaint with us is not satisfactorily resolved, you can contact
    the Complaint Assistance Unit of the Division of Consumer Services of the
    California Department of Consumer Affairs in writing at 1625 North Market
    Blvd., Suite N 112, Sacramento, California 95834 or by telephone at (800)
    952-5210 or (916) 445-1254.
  </p>

  <h2>MISCELLANEOUS</h2>
  <p>
    These Terms of Use and any policies or operating rules posted by us on the
    Website or in respect to the Website constitute the entire agreement and
    understanding between you and us. Our failure to exercise or enforce any
    right or provision of these Terms of Use shall not operate as a waiver of
    such right or provision. These Terms of Use operate to the fullest extent
    permissible by law. We may assign any or all of our rights and obligations
    to others at any time. We shall not be responsible or liable for any loss,
    damage, delay, or failure to act caused by any cause beyond our reasonable
    control. If any provision or part of a provision of these Terms of Use is
    determined to be unlawful, void, or unenforceable, that provision or part
    of the provision is deemed severable from these Terms of Use and does not
    affect the validity and enforceability of any remaining provisions. There
    is no joint venture, partnership, employment or agency relationship
    created between you and us as a result of these Terms of Use of the
    Website. You agree that these Terms of Use will not be construed against
    us by virtue of having drafted them. You hereby waive any and all defenses
    you may have based on the electronic form of these Terms of Use and the
    lack of signing by the parties hereto to execute these Terms of Use.
  </p>

  <h2>CONTACT US</h2>
  <p>
    In order to resolve a complaint regarding the Website or to receive
    further information regarding use of the Website, please contact us at:
  </p>
  <p>
    Silk Road LLC<br />
    1748 Delaney Ferry Rd<br />
    Nicholasville, KY 40356-8729<br />
    United States<br />
    Phone: (+1) 859-312-4115<br />
    <a href="mailto:k.stuebs@bidxsell.com">k.stuebs@bidxsell.com</a><br />
    or
    <br />
    <a href="mailto:s.almaddah@bidxsell.com">s.almaddah@bidxsell.com</a>
  </p>
</div>
</div> -->

<div id="terms" class="container h-100">
  @if (!isLoading) {
    <div class="content" [innerHTML]="data"></div>
  }
  @if (isLoading) {
    <div
      class="d-flex justify-content-center h-100 align-items-center flex-column"
      >
      @for (
        item of [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20
        ]
        ; track
        item) {
        <app-skeleton-loader
          class="col-12"
          type="text"
        ></app-skeleton-loader>
      }
    </div>
  }
</div>
